import { AxiosResponse } from 'axios';
import { USERS_API_URL } from '../../../../config';
import brokersAxios from '../../../../utils/axios/brokers-roles.axios';
import { PaginatedNotifications } from '../../../../interfaces/notifications/paginatedStore.type';

const tryToFetchNotifications = (
    pageNumber: number,
    pageSize: number,
    data?: any,
    filters?: string,
): Promise<AxiosResponse<PaginatedNotifications>> => {
    const url = filters
        ? `${USERS_API_URL}/hotel-world-notifications/user-management?page=${pageNumber}&size=${pageSize}&search=${filters}`
        : `${USERS_API_URL}/hotel-world-notifications/user-management?page=${pageNumber}&size=${pageSize}`;
    return brokersAxios.put<PaginatedNotifications>(url, data);
};

const tryToFetchAllNotifications = (): Promise<AxiosResponse<any>> => {
    return brokersAxios.get(`${USERS_API_URL}/hotel-world-notifications/user-management/all`);
};

const tryToFetchSingleNotification = (id: string): Promise<AxiosResponse<any>> => {
    return brokersAxios.get(`${USERS_API_URL}/hotel-world-notifications/user-management/${id}`);
};

const tryToMarkNotificationsAsRead = (data: any): Promise<AxiosResponse<any>> => {
    return brokersAxios.put(`${USERS_API_URL}/hotel-world-notifications/user-management/read`, data);
};

export const NotificationsService = {
    tryToFetchNotifications,
    tryToFetchAllNotifications,
    tryToFetchSingleNotification,
    tryToMarkNotificationsAsRead
};